import { AccountRegions } from '@payaca/types/accountTypes';
import { CurrencyCodes } from '@payaca/types/currencyTypes';

export const currencyCodeForRegion: Record<AccountRegions, CurrencyCodes> = {
  [AccountRegions.AUSTRALIA]: CurrencyCodes.AUD,
  [AccountRegions.CANADA]: CurrencyCodes.CAD,
  [AccountRegions.IRELAND]: CurrencyCodes.EUR,
  [AccountRegions.NEW_ZEALAND]: CurrencyCodes.NZD,
  [AccountRegions.SOUTH_AFRICA]: CurrencyCodes.ZAR,
  [AccountRegions.UK]: CurrencyCodes.GBP,
  [AccountRegions.US]: CurrencyCodes.USD,
};

// https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts
const minimumStripeCurrencyAmount: Record<CurrencyCodes, number> = {
  [CurrencyCodes.AUD]: 50,
  [CurrencyCodes.CAD]: 50,
  [CurrencyCodes.EUR]: 50,
  [CurrencyCodes.NZD]: 50,
  [CurrencyCodes.ZAR]: 50,
  [CurrencyCodes.GBP]: 30,
  [CurrencyCodes.USD]: 50,
};

export const getMinimumStripeChargeAmountForRegion = (
  region: AccountRegions
) => {
  return minimumStripeCurrencyAmount[currencyCodeForRegion[region]];
};
